module.exports = __webpack_public_path__ + "assets/jon-profile-d4ca62a42d272c9abd89c545982dc250.jpg";